var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.visible, "show-close": false },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "verify" },
        [
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "back", on: { click: _vm.closeFirst } }, [
              _c("i", { staticClass: "el-icon-arrow-left" }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "verify-up" },
            [
              _vm.flag == "completed" || _vm.flag == "approved"
                ? [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/success.png"),
                        alt: ""
                      }
                    })
                  ]
                : _vm.flag == "inReview"
                ? [
                    _c("img", {
                      attrs: { src: require("../../assets/ing.png"), alt: "" }
                    })
                  ]
                : _vm.flag == "declined"
                ? [
                    _c("img", {
                      attrs: { src: require("../../assets/error.png"), alt: "" }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.flag == "completed" || _vm.flag == "approved"
                ? _c("div", { staticClass: "title" }, [
                    _vm._v("\n          Active\n        ")
                  ])
                : _vm.flag == "inReview"
                ? _c("div", { staticClass: "title" }, [_vm._v("In Review")])
                : _vm.flag == "declined"
                ? _c("div", { staticClass: "title" }, [
                    _vm._v("\n          Decline\n        ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.flag === "inReview" && _vm.bankFlag === "false"
                ? _c("div", { staticClass: "desc" }, [
                    _vm._v(
                      "\n          Thanks, you completed the on-boarding process with ShopVidi We will\n          complete the review within 1 working day.\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.flag === "inReview" && _vm.bankFlag === "true"
                ? _c("div", { staticClass: "desc" }, [
                    _vm._v(
                      "\n          Thank you, you have completed the onboarding process through ShopVidi\nWe will complete the review within 1 minute.\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.flag === "declined"
                ? _c("div", { staticClass: "desc" }, [
                    _vm._v(
                      "\n          Your 60 net terms application Declined,Contact customer service.\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.flag === "completed"
                ? _c("div", { staticClass: "desc" }, [
                    _vm._v(
                      "\n          Your review of 60 net terms has Active.\n        "
                    )
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "verify-down" }, [
            _c("div", { staticClass: "list" }, [
              _c("div", { staticClass: "item" }, [
                _vm.business !== ""
                  ? _c("div", { staticClass: "name" }, [
                      _vm._v("Business Name：")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "cont" }, [
                  _vm._v(_vm._s(_vm.business))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item" }, [
                _c("div", { staticClass: "name" }, [_vm._v("Email：")]),
                _vm._v(" "),
                _c("div", { staticClass: "cont" }, [
                  _vm._v(_vm._s(this.$ls.get("userInfo").email))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item" }, [
                _c("div", { staticClass: "name" }, [
                  _vm._v("Terms Qualification:")
                ]),
                _vm._v(" "),
                _vm.flag == "completed" || _vm.flag == "approved"
                  ? _c("div", { staticClass: "cont" }, [
                      _vm._v("\n              Active\n            ")
                    ])
                  : _vm.flag == "inReview"
                  ? _c("div", { staticClass: "cont" }, [_vm._v("In Review")])
                  : _vm.flag == "declined"
                  ? _c("div", { staticClass: "cont" }, [
                      _vm._v("\n              Decline\n            ")
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn-border" }, [
              _vm.flag == "declined"
                ? _c(
                    "div",
                    { staticClass: "btn", on: { click: _vm.openSecond } },
                    [_vm._v("Re-Apply")]
                  )
                : _c(
                    "div",
                    { staticClass: "btn", on: { click: _vm.backHome } },
                    [_vm._v("Back Home")]
                  ),
              _vm._v(" "),
              _vm.checkoutPath !== ""
                ? _c(
                    "div",
                    { staticClass: "btn", on: { click: _vm.backCheckout } },
                    [_vm._v("Back Checkout")]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "footer" }, [
              _vm._v(
                "\n          You can check the application status of net terms in the menu at the top\n          right corner of the page or check the status of net terms application in\n          the checkout page.\n        "
              )
            ])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17c1310a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c1310a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/credit-payment/verifyDialog.vue
// module id = null
// module chunks = 